<ng-container *ifScreenSize="screenType.Desktop">
  <div class="banner" role="banner">
    <h1>{{ 'games.page.pick.player.title' | translate }}</h1>
  </div>
</ng-container>

<div class="container">
  <div class="d-lg-none mt-2">
    <div class="page-back-button-section" [routerLink]="['/games/pickaplayer']">
      <span class="material-icons me-2">navigate_before</span>{{ 'games.back.button.text' | translate }}
    </div>
  </div>
  <div class="row my-3">
    <div class="col-lg-4 col-12">
      <fgb-fantasy-game-panel
        [game]="game$ | async"
        (button)="confirmSelection()"
        [buttonState]="button"
        [horizontal]="false"
      ></fgb-fantasy-game-panel>
    </div>
    <div class="col-lg-8 col-12 mt-lg-0 mt-4">
      <div class="row">
        <div class="col-lg-3 col-6" *ngFor="let player of players$ | async">
          <div class="rounded overflow-hidden mb-3 border-0" (click)="select(player.PlayerId)">
            <img alt="Player Picture" class="card-img-top w-100" src="{{ player.Image | contentImage : '7' }}" />
            <div
              class="card-body d-flex justify-content-start align-items-center"
              [ngClass]="{ 'bg-secondary text-black': player.IsSelected, 'text-white bg-primary': !player.IsSelected }"
            >
              <div class="mx-auto mb-0 font-size-12 text-capitalize">{{ player.PlayerName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-none d-lg-block">
    <div class="page-back-button-section" [routerLink]="['/games/pickaplayer']">
      <span class="material-icons me-2">navigate_before</span>{{ 'games.back.button.text' | translate }}
    </div>
  </div>
</div>
